// Shared by AnalyseBody (V2) and V3CompanyProfile (V3) — both render the same
// `general` analysis insights text, which uses **bold** / leading-label / list-item
// markup that needs converting to HTML before display.

export function formatAnalysisText(text: string, highlightText?: boolean): string {
  if (!text || typeof text !== 'string') return '';

  const withListBreaks = text.replaceAll(/(?<=\.)-(?=\s)/g, '.\n-');
  const withBold = highlightText
    ? withListBreaks.replaceAll(/^([^:\n]+):/gm, '<strong class="bold">$1</strong>:')
    : withListBreaks.replaceAll(/\*\*(.*?)\*\*/g, '<strong class="bold">$1</strong>');

  const withListSpan = withBold.replaceAll(/^[-*•]\s(.+)$/gm, '<span class="listItem">$1</span>');

  let html = withListSpan.replaceAll('\n', '<br>');
  html = html.replaceAll(/(<br>){3,}/g, '<br><br>');

  return html;
}

export function normalizeAnalysisText(v: unknown): string | null {
  if (Array.isArray(v)) return v.filter(Boolean).join('\n');
  if (typeof v === 'string') return v;
  return null;
}

export interface CompanyInsightSection {
  title: string;
  text: string;
}

// The "3 main blocks" of the company (general/action) analysis — same mapping V2's
// AnalyseBody uses, kept here so V3's version can't drift from it.
const COMPANY_INSIGHT_TITLES: Record<string, string> = {
  company_overview: 'Das Unternehmen',
  business_model: 'Business-Modell',
  growth_drivers_and_strategic_initiatives: 'Wachstumstreiber & strategische Initiativen',
};

export function mapCompanyInsights(
  insights: Record<string, unknown> | null | undefined,
): CompanyInsightSection[] {
  if (!insights?.['business_model']) return [];

  return Object.keys(COMPANY_INSIGHT_TITLES)
    .filter((key) => insights[key])
    .map((key) => {
      const text = normalizeAnalysisText(insights[key]);
      if (!text) return null;
      return { title: COMPANY_INSIGHT_TITLES[key], text };
    })
    .filter(Boolean) as CompanyInsightSection[];
}
